var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackReportsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.04,
    height: 38.4,
    rx: 8,
    fill: "#EBF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.19 21.816V18.7643C31.19 16.5973 28.9063 14.8406 26.0892 14.8406H23.8222C22.8832 14.8406 22.122 14.2551 22.122 13.5327V11.7889C22.122 9.62191 19.8383 7.86523 17.0212 7.86523H14.1875M14.1875 22.6879H25.5225M14.1875 26.1756H19.855M17.588 7.86523H10.2202C9.28122 7.86523 8.51999 8.45079 8.51999 9.17312V29.2273C8.51999 29.9497 9.28122 30.5352 10.2202 30.5352H29.4897C30.4288 30.5352 31.19 29.9497 31.19 29.2273V18.3283C31.19 12.5497 25.1002 7.86523 17.588 7.86523Z",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackReportsImage);
export default __webpack_public_path__ + "static/media/Feedback-reports-image.100dfcc06081352872f4cf221b5a93e7.svg";
export { ForwardRef as ReactComponent };